import { sanitizeContent } from '../../shared-core/utils';

function pageTitle(title: string) {
  const sanitizedTitle = sanitizeContent(title);

  return `${sanitizedTitle.length > 0 ? `${sanitizedTitle} - ` : ''}LessonUp`;
}

export default pageTitle;
